__webpack_require__.p = "/vk-kanban/";